import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Grow } from '@material-ui/core'
import clsx from 'clsx'
import { useCurrentUser } from 'api/User/Users/queries'
import { useReaderContext } from './context/reader-context'

const useStyles = makeStyles((theme) => ({
  frameWrapper: {
    height: `calc(100vh - ${62}px)`,
  },

  iframe: {
    width: '100%',
    height: '100%',
  },
}))

const DigiIebookReaderFrame = React.forwardRef(
  (
    { frameSrc = '', loaded = false, frameMargin = '0px', onLoad = () => {} },
    ref
  ) => {
    const classes = useStyles()

    const {
      iRef,
      info: { packageId },
    } = useReaderContext()

    const currentUser = useCurrentUser()

    React.useEffect(() => {
      let newmessage
      let payload
      payload = {
        action: 'userInfo',
        package_id: packageId,
        userRole: currentUser?.data?.User_roles,
      }
      newmessage = JSON.stringify(payload)
      iRef?.current.contentWindow.postMessage(newmessage, '*')
    }, [])

    return (
      <>
        {frameSrc ? (
          <div className={clsx(classes.frameWrapper)}>
            <Grow in={loaded}>
              <iframe
                title="digiiebook-reader-frame"
                ref={ref}
                id="iframe"
                name="iframe"
                loading="lazy"
                frameBorder="0"
                onLoad={onLoad}
                src={frameSrc}
                style={{
                  marginLeft: frameMargin,
                }}
                allowfullscreen="true"
                className={clsx(classes.iframe)}
              />
            </Grow>
          </div>
        ) : null}
      </>
    )
  }
)

DigiIebookReaderFrame.displayName = DigiIebookReaderFrame

DigiIebookReaderFrame.propTypes = {
  loaded: PropTypes.bool,
  frameSrc: PropTypes.string,
  frameMargin: PropTypes.string,
  onLoad: PropTypes.func,
}

export default DigiIebookReaderFrame
